/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { AddToCalendarPlacement, AlertPlacement } from 'enums';
import AddToCalendarContainer from 'common/AddToCalendar';
import playingContentSelector from 'selectors/playingContentSelector';
import { isEmpty } from 'lib/util';

class Alert extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dismissed: false
        };
        this.onClose = this.onClose.bind(this);
    }

    onClose(event) {
        event.preventDefault();
        // allow onClose behavior to be passed in, otherwise default to permanently dismiss
        if (typeof this.props.onClose === 'function') {
            this.props.onClose(event);
        } else {
            this.setState({ dismissed: true });
        }
    }

    render() {
        const { display, displayTime, content, placement, playingContent } = this.props;
        const { name, source } = content || {};
        const startTimeEl = <span>{displayTime}</span>;

        if (!this.state.dismissed && display) {
            // TODO: next update in score should allow us to not override zindex
            switch (placement) {
                case AlertPlacement.EVENT_CARD: {
                    const alertClasses = 'alert alert--center alert__animateSlideIn alert__animateSlideIn--run';
                    return (
                        <div className="alert__isOverlay">
                            <div className={alertClasses}>
                                <p>{name} is scheduled to begin at {startTimeEl} on {source}.</p>
                                <a onClick={this.onClose} className="alert_button--close icon-font-after icon-close-solid-after" />
                                { /* <AddToCalendarContainer content={content} placement={AddToCalendarPlacement.ALERT} /> */ }
                            </div>
                        </div>
                    );
                }
                case AlertPlacement.PLAYER: {
                    const alertClasses = 'alert alert__animateFadeIn alert__animateFadeIn--run';
                    const enjoyText = !isEmpty(playingContent) ?
                        `Please enjoy ${playingContent.name} while you wait.` : '';
                    return (
                        <div className="alert__isOverlay" style={{ position: 'absolute', top: '0px' }}>
                            <div className={alertClasses}>
                				<p>{name} is scheduled to begin at {startTimeEl} on {source}. {enjoyText}</p>
                				<a onClick={this.onClose} className="alert_button--close icon-font-after icon-close-solid-after" />
                			</div>
                        </div>
                    )
                }
                default:
                    return null;
            }
        }
        return null;
    }
}

Alert.propTypes = {
    content: React.PropTypes.object,
    display: React.PropTypes.bool,
    displayTime: React.PropTypes.string,
    onClose: React.PropTypes.func,
    placement: React.PropTypes.string,
    playingContent: React.PropTypes.object
};

const mapStateToProps = (state, props) => ({
    playingContent: playingContentSelector(state)
});

export default connect(mapStateToProps)(Alert);



// WEBPACK FOOTER //
// ./app/common/Alert.js